{
  "add": "Ajouter",
  "create": "Créer",
  "confirm": "Confirmer",
  "creating": "Création...",
  "proceed": "Procéder",
  "update": "Mettre à jour",
  "edit": "Modifier",
  "cancel": "Annuler",
  "delete": "Supprimer",
  "process": "Traiter",
  "save": "Enregistrer",
  "later": "Plus tard",
  "next": "Suivant",
  "continue": "Continuer",
  "activate": "Activer",
  "deactivate": "Désactiver",
  "error": "Erreur",
  "search": "Recherche",
  "download": "Télécharger",
  "warning": "Avertissement",
  "notRequired": "Non requis",
  "notEditable": "Non modifiable",
  "goalValue": "de {{goalValue}}",
  "overfundedBy": "Surfinancé de {{percentage}} %",
  "sign": "Signer",
  "upload": "Importer",
  "reupload": "Recharger",
  "retry": "Réessayer",
  "import": "Importer",
  "validationError": {
    "unique": "Cet enregistrement existe déjà. Veuillez sélectionner un autre",
    "sessionTimeout": "Votre session a expiré. Veuillez vous reconnecter.",
    "tokenRefreshFailed": "Votre session a expiré. Veuillez vous reconnecter.",
    "duplicateRecord": "Un enregistrement avec ces valeurs existe déjà. Veuillez utiliser des valeurs uniques."
  },
  "backendIssuedError": {
    "organizationUserNotFound": "Configuration en cours ou profil non enregistré. Veuillez réessayer plus tard."
  },
  "enable": "Activer",
  "enabled": "Activé",
  "disable": "Désactiver",
  "disabled": "Désactivé",
  "inheritedFlag": "Hérité",
  "inheritedTooltip": "Ce {{model}} a été hérité de l'organisation {{organization}}. Veuillez contacter l'organisation {{organization}} pour le modifier.",
  "yes": "Oui",
  "no": "Non",
  "inherited": "Hérité",
  "any": "Tous",
  "true": "Vrai",
  "false": "Faux",
  "requiedField": "Champ requis!",
  "required": "Requis",
  "requireAffiliate": "Les comptes {{accountType}} nécessitent au moins un {{affiliateType}}",
  "noPermission": "Vous n'avez pas l'autorisation d'accéder à cet espace",
  "missingPermissionIs": "l'autorisation manquante est",
  "back": "Retour",
  "yesExit": "Oui, quitter",
  "wizardInterruptionMsg": "La fermeture de cette fenêtre effacera votre progression. Êtes-vous sûr de vouloir quitter ?",
  "wizardTitle": "Sortir de '{{wizardTitle}}' ?",
  "somethingBelongingToSomeone": "Les {{whose}} de {{what}}",
  "household": "ménage",
  "powerOfAttorney": "Procuration",
  "okGotIt": "D'accord, j'ai compris",
  "copyToClientNotes": "Copier dans les notes du client",
  "organization": "Organisation",
  "inheritedDashWhat": "Hérité - {{what}}",
  "someErrorHasOccurred": "Une erreur s'est produite!",
  "completed": "Terminé",
  "relationship": "Relation",
  "phoneNumber": "Numéro de téléphone",
  "email": "Courriel",
  "status": "Statut",
  "state": "État",
  "entity": "Entité",
  "markAllAsRead": "Marquer tous comme lus",
  "noNotifications": "Vous n'avez pas de notifications",
  "notificationsMenu": {
    "title": "Notifications",
    "ALL": "Toute l'activité",
    "UNREAD": "Non lu",
    "today": "Aujourd'hui"
  },
  "done": "Terminé",
  "clearAll": "Effacer tout",
  "addNewColumn": "Ajouter une colonne",
  "commaSeparated": "Séparé par une virgule",
  "securityDetails": "Détails de la valeur mobilière",
  "name": "Nom",
  "type": "Type",
  "cash": "Trésorerie",
  "actions": "Actions",
  "archive": "Archive",
  "only": "uniquement",
  "notClassified": "Non classifié",
  "publish": "Publier",
  "unpublish": "Annuler la publication",
  "viewAll": "Tout afficher",
  "published": "Publié",
  "inactive": "Inactif",
  "saved": "Enregistré",
  "successfullySaved": "Enregistrement réussi",
  "filter": "Filtre",
  "perPage": "par page",
  "perPageWithSize": "{{size}} par page",
  "copiedToClipboard": "Copié dans le presse-papiers",
  "country": "Pays",
  "fixedColumn": "Colonne fixe",
  "tableDefinition": "Les tableaux peuvent être configurés pour afficher un certain nombre de points de données. Sur les petits écrans, la première colonne reste fixe, ce qui permet de faire défiler les autres horizontalement. La version mobile simplifiée n'affiche que les informations essentielles, et un appui sur la ligne permet de visualiser l'ensemble des données.",
  "browserTable": "Tableau pour navigateur",
  "mobileTable": "Tableau mobile",
  "on": "sur",
  "print": "Imprimer",
  "continued": "suite",
  "auditLog": "Rapport d'activité",
  "start": "Commencer",
  "end": "Fin",
  "invalidObjectId": "Identifiant d'objet non valide",
  "submit": "Soumettre",
  "loading": "Chargement...",
  "copyID": "Copier l'identifiant",
  "description": "Description",
  "inactiveModal": {
    "headingText": "Êtes-vous encore là?",
    "prefixButton": "Gardez-moi connecté",
    "suffixButton": "Se déconnecter maintenant",
    "bodyText1": "En raison d'inactivité, votre session expirera dans",
    "bodyText2": "secondes."
  },
  "SessionTimeoutLayoutModal": {
    "loginButton": "Se connecter",
    "headingText": "Vous avez été déconnecté",
    "bodyText": "En raison d'inactivité, votre session a expiré. Si vous souhaitez continuer à utiliser OneVest, veuillez vous reconnecter."
  },
  "withdraw": "Retrait",
  "deposit": "Dépôt",
  "amountUnavailable": " Montant indisponible",
  "errorStateSubText": "Il y a un problème avec le système. Veuillez réessayer plus tard.",
  "errroStateTitle": "Impossible de charger les données",
  "errroStateAccountTitle": "Impossible de charger les comptes",
  "errroStateGoalTitle": "Impossible de charger les objectifs",
  "paginationSummary": "{{start}}-{{end}} sur {{total}}",
  "genderOptions": {
    "MALE": "Masculin",
    "FEMALE": "Féminin",
    "OTHER": "Un autre genre"
  },
  "invalidAllocations": "L'allocation totale pour chaque type d'affiliation doit être exactement de 100 %.",
  "maxAttemptsExceeded": "Vous avez atteint le nombre maximal de tentatives. Veuillez contacter le service d'assistance.",
  "failedVerificationAttemp": "Certaines réponses de vérification sont incorrectes. Il vous reste {{attempt}} tentative(s).",
  "profileDetailsUpdated": "Les détails du profil ont été mis à jour.",
  "objectUpdated": "{{object}} mis à jour avec succès.",
  "objectClosed": "{{object}} a été fermé.",
  "objectArchived": "{{object}} a été archivé.",
  "unsafeUrl": "URL invalide ou non sécurisée. Le lien n'a pas pu être ouvert pour des raisons de sécurité.",
  "draft": "Brouillon",
  "nameRequired": "Nom requis",
  "objectId": "ID d'objet",
  "validObjectId": "ID d'objet valide",
  "dataTablePaginationSummary": "Lignes : {{start}}–{{end}} sur {{total}}",
  "rowsPerPage": "Lignes par page :",
  "close": "Fermer",
  "unknownOrganization": "Inconnu",
  "relationshipInformation": {
    "selectSpouse": "Sélectionner le conjoint",
    "selectTrustedContact": "Sélectionner la personne de contact de confiance",
    "clearSelectedSpouse": "Effacer le conjoint sélectionné",
    "clearSelectedTrustedContact": "Effacer le TCP sélectionné",
    "relationUpdateError": "Une erreur est survenue lors de la mise à jour de la relation. Veuillez réessayer."
  },
  "saveForLater": "Enregistrer pour plus tard",
  "somethingWentWrong": "Un problème est survenu",
  "home": "Accueil",
  "unknownRole": "Rôle inconnu",
  "organizationSwitchNotSaved": "Votre modification n'a pas été enregistrée. Vous n'avez peut-être pas la permission de modifier ce paramètre."
}
